import { useAppContext } from "../../AppContext";
import styles from "./index.module.css";

interface ITitle {
  text: TranslateDescriptor;
}

function Title({ text }: ITitle) {
  const { intl } = useAppContext();
  return (
    <div className={styles.title} page-component="Title">
      {intl.formatMessage(text)}
    </div>
  );
}

export default Title;
